<template>
  <div>
    <Spinner ref="spinner" :block="true"/>
    <Calendar id="paidAt" v-model="filter.paidAt"/>
    <modal-to-reverse-card-transactions
      :cardTransactions="cardTransactionSelected"
      :isReplay="isReplay"
      />
    <div class="container-fluid">
      <form class="form-row" @submit.prevent="search">
        <div class="col-5">
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-prepend">
                <select class="form-control" v-model="filter.searchType">
                  <option value="nsu">NSU</option>
                  <option value="acquirerNsu">NSU da adquirente</option>
                  <option value="amountPaid">Valor pago</option>
                  <option value="taxDocument">CPF do Representante</option>
                  <option value="cardFinal">Final do cartão</option>
                </select>
              </div>
              <input
                v-show="filter.searchType === 'nsu'"
                v-model="filter.nsu"
                type="text"
                class="form-control"
                placeholder="NSU"
                id="nsu"
                >
              <input
                v-show="filter.searchType === 'acquirerNsu'"
                v-model="filter.acquirerNsu"
                type="text"
                class="form-control"
                placeholder="Nsu da adquirente"
                id="acquirerNsu"
                >
              <input
                v-show="filter.searchType === 'taxDocument'"
                v-model="filter.taxDocument"
                type="text"
                class="form-control"
                placeholder="CPF do representante"
                maxlength="14"
                v-mask="['###.###.###-##']"
                id="taxDocument"
                >
              <money
                v-if="filter.searchType === 'amountPaid'"
                v-model="filter.amount"
                type="text"
                class="form-control"
                placeholder="Valor pago"
                v-bind="{decimal: ',', thousands:'.', prefix:'R$', precision:2, masked: false}"
                id="amountPaid"
                ></money>
              <input
                v-show="filter.searchType == 'cardFinal'"
                v-model="filter.cardFinal"
                type="text"
                maxlength="4"
                class="form-control"
                placeholder="ultimos 4 digitos do cartão"
                id="cardFinal"
                >
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <select class="form-control" v-model="filter.cardBrand">
              <option value selected>Todas as bandeiras</option>
              <option value="visa">Visa</option>
              <option value="banesecard">Banesecard</option>
              <option value="dinersclub">Dinersclub</option>
              <option value="elo">Elo</option>
              <option value="hipercard">Hipercard</option>
              <option value="mastercard">Mastercard</option>
              <option value="amex">Amex</option>
            </select>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <select class="form-control" v-model="filter.type">
              <option value selected>Todos os tipos</option>
              <option value="pre">Pré-capturadas</option>
            </select>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="input-group">
              <div class="form-control">
                <span class="text-secondary" v-if="filter.paidAt">
                <small class="text-secondary">no dia</small>
                &nbsp; {{ filter.paidAt | date }}
                </span>
                <span class="text-secondary" v-else>data de transação</span>
              </div>
              <div class="input-group-append">
                <button
                  type="button"
                  class="btn btn-info"
                  data-toggle="modal"
                  data-target="#paidAt"
                  >
                <i class="icon-calendar"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-auto">
          <button type="button" @click="search" class="btn btn-info mr-2">
          <i class="icon-magnifier"></i>
          </button>
          <button type="button" class="btn btn-outline-secondary" @click="reset">
          <i class="icon-trash"></i>
          </button>
        </div>
      </form>
      <div class="row mb-5">
        <div class="col-auto">
          <div class="btn-group btn-group-toggle">
            <label for="approved" class="btn btn-outline-success" :class=" { 'active' : filter.status.includes('approved') } ">
              <input type="checkbox" v-model="filter.status" value="approved" id="approved"> Aprovadas
            </label>
            <label class="btn btn-outline-reproved" :class=" { 'active' : filter.status.includes('reproved') } ">
              <input type="checkbox" v-model="filter.status" value="reproved" id="reproved"> Reprovadas
            </label>
            <label class="btn btn-outline-secondary" :class=" { 'active' : filter.status.includes('canceled') } ">
              <input type="checkbox" v-model="filter.status" value="canceled" id="canceled"> Canceladas
            </label>
            <label class="btn btn-outline-danger" :class=" { 'active' : filter.status.includes('contested') } ">
              <input type="checkbox" v-model="filter.status" value="contested" id="contested"> Contestadas
            </label>
            <label class="btn btn-outline-info" :class=" { 'active' : filter.status.includes('pending') } ">
              <input type="checkbox" v-model="filter.status" value="pending" id="pending"> Pendentes
            </label>
          </div>
        </div>
        <div class="col small-paragraph pl-4">
          <small class="text-muted">
            Status do Adquirente:
            <br>
            <span class="text-nowrap">
              <i class="fa fa-circle font-sm text-success"></i> Aprovada
            </span> |
            <span class="text-nowrap">
              <i class="fa fa-circle font-sm text-reproved"></i> Reprovada
            </span> |
            <span class="text-nowrap">
              <i class="fa fa-circle font-sm text-secondary"></i> Cancelada
            </span> |
            <span class="text-nowrap">
              <i class="fa fa-circle font-sm text-danger"></i> Contestada
            </span> |
            <span class="text-nowrap">
              <i class="fa fa-circle font-sm text-pending"></i> Pendente
            </span> |
            <span class="text-nowrap">
              <i class="fa fa-circle font-sm text-warning"></i> Canc. negado
            </span>
          </small>
        </div>
        <div class="col-auto">
          <button
            class="btn btn-danger"
            data-toggle="modal"
            data-target="#modalTransactions"
            @click="isReplay = false"
            v-if="cardTransactionSelected.length > 0"
            >Estornar {{cardTransactionSelected.length}} </button>
        </div>
        <div class="col-auto">
          <button
            class="btn btn-danger"
            data-toggle="modal"
            data-target="#modalTransactions"
            @click="isReplay = true"
            v-if="cardTransactionSelected.length > 0"
            >Constestar {{cardTransactionSelected.length}}</button>
        </div>
      </div>
      <div v-if="cardTransactionsList && count > 0">
        <div class="mb-2 ml-1">
          <div class="row">
            <div class="col-12 col-w-full">
              <div>
                <div class="row m-0">
                  <div class="pl-5 pt-5 pt-2 d-flex">
                    <div class="d-flex mb-1">
                    </div>
                  </div>
                  <div class="col col-lg text-center mb-3 mr-5 ml-3">
                    <span class="font-10">Lojista</span>
                  </div>
                  <div class="text-center mb-3 mx-5 pl-4">
                    <span class="font-10">Data da transação</span>
                  </div>
                  <div class="col col-lg text-center mb-3 pl-5">
                    <span class="font-10">Bandeira/Final</span>
                  </div>
                  <div class="col col-lg text-center mb-3 pl-4 pr-1">
                    <span class="font-10">NSU</span>
                  </div>
                  <div class="col col-lg text-center mb-3 pr-3 ml-4">
                    <span class="font-10">Adquirente/NSU</span>
                  </div>
                  <div class="col col-lg text-center mb-3">
                    <span class="font-10">Tipo</span>
                  </div>
                  <div class="col col-lg text-center mb-3 pl-2">
                    <span class="font-10">Status</span>
                  </div>
                  <div class="text-center mb-3 pl-1 pr-3">
                    <span class="font-10">Status adquirente</span>
                  </div>
                  <div class="text-center mb-3 pr-3">
                    <span class="font-10">Valor autorizado</span>
                  </div>
                  <div class="col col-lg text-center mb-3 mr-4">
                    <span class="font-10">Valor pago</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-2" v-for="transaction in cardTransactionsList" :key="transaction.nsu">
          <div class="row">
            <div class="col-12 col-w-full">
              <div class="card card-action py-4 mb-3">
                <div class="row m-0">
                  <div class="pl-3 pt-2 d-flex">
                    <div class="d-flex mb-1">
                      <label class="radio-selector">
                        <input type="checkbox" :value="transaction" v-model="cardTransactionSelected">
                        <div class="checkbox-badge"></div>
                      </label>
                    </div>
                  </div>
                  <div class="col col-xl-2 order-1 d-flex ml-3">
                    <div class="d-flex mb-1">
                      <span class="d-flex">
                      <i class="icon-user m-auto"></i>
                      </span>
                    </div>
                    <div class="ml-2 order-3 small-paragraph">
                      <span class="font-11">{{ transaction.seller.personName }}</span><br>
                      <span class="font-10">{{ transaction.seller.personTaxDocument }}</span>
                    </div>
                  </div>
                  <div class="col-12 col-lg col-xl-2 order-3 d-flex text-center text-sm mb-3 mb-lg-0">
                    <span class="font-10 pt-2">{{ transaction.paidAt | datetime }}</span>
                  </div>
                  <div class="col-12 col-lg col-xl-1 order-3 d-flex text-center text-sm mb-3 mb-lg-0">
                    <span class="payment-method pt-1" :class="transaction.cardBrand"></span>
                    <small class="font-10 pl-2 pt-2">{{ transaction.cardNumber.substr(12, 4) }}</small>
                  </div>
                  <div class="col-12 col-lg order-3 d-flex text-center text-sm mb-3 mb-lg-0">
                    <small class="font-10 pt-2">{{ transaction.nsu }}</small>
                  </div>
                  <div class="col-12 col-lg col-xl-1 order-3 ml-2 text-center small-paragraph">
                    <span class="font-11">{{ transaction.acquirer }}</span><br>
                    <span class="font-10" v-if="transaction.acquirerNsu">{{ transaction.acquirerNsu }}</span>
                  </div>
                  <div class="col-12 col-lg order-3 d-flex text-secondary text-sm my-auto mb-3">
                    <div class="tooltips" data-direction="bottom">
                      <div class="tooltips__initiator" v-if="transaction.dueCaptureDate">
                        <span class="badge badge-outline-secondary badge-pill ml-2 font-10">
                        PRE
                        </span>
                      </div>
                      <div class="tooltips__item">
                        <div>
                          <span>Aprovada em:</span>
                          <br />
                          <span>{{ transaction.approvedAt | date }}</span>
                        </div>
                        <div>
                          <br /><br />
                          <span>Expira em:</span>
                          <br />
                          <span>{{ transaction.dueCaptureDate | date }}</span>
                        </div>
                        <div v-if="transaction.capturedAt">
                          <br /><br />
                          <span>Capturada em:</span>
                          <br />
                          <span>{{ transaction.capturedAt | date }}</span>
                        </div>
                        <div v-if="transaction.canceledAt">
                          <br /><br />
                          <span>Cancelado em:</span>
                          <br />
                          <span>{{ transaction.canceledAt | date }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg order-3 d-flex text-secondary text-sm my-auto mb-3">
                    <span
                      class="badge badge-pill text-uppercase font-9" :class="status(transaction)">
                    {{ transaction.status }}
                    </span>
                  </div>
                  <div class="col-12 col-lg order-3 d-flex text-secondary text-sm my-auto mb-3">
                    <span
                      class="badge badge-pill text-uppercase font-9" :class="acquirerStatus(transaction)">
                    {{ transaction.acquirerStatus }}
                    </span>
                  </div>
                  <div class="col-12 col-lg order-3 d-flex text-center text-sm mb-3 mb-lg-0">
                    <span class="font-10 pt-2">{{ transaction.amountPaid | currency("R$ ", 2, { decimalSeparator: ',' , thousandsSeparator: '.'}) }}</span>
                  </div>
                  <div class="col-12 col-lg order-3 d-flex text-center text-sm mb-3 mb-lg-0">
                    <span class="font-10 pt-2">{{ transaction.amountPaid | currency("R$ ", 2, { decimalSeparator: ',' , thousandsSeparator: '.'}) }}</span>
                  </div>
                  <div class="dropdown order-3 d-flex">
                    <button
                      class="btn btn-lg btn-link p-0"
                      type="button"
                      id="dropdownMenu2"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      >
                    <i class="icon-options-vertical"></i>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                      <button
                        class="dropdown-item"
                        type="button"
                        data-toggle="modal"
                        data-target="#modalTransactions"
                        @click="emitCardTransaction(transaction, false)"
                        >Estornar</button>
                      <button
                        class="dropdown-item"
                        type="button"
                        data-toggle="modal"
                        data-target="#modalTransactions"
                        @click="emitCardTransaction(transaction, true)"
                        >Contestar</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <paginator :count="count" :perPage="perPage" @exchange="turnPage"/>
    </div>
    <div v-if="count == 0">
      <div class="text-center">
        <span class="h4">
        <i class="icon-magnifier"></i> Pesquise a partir dos filtros a cima
        </span>
      </div>
      <div class="text-center">
        <span class="text-muted">Nenhum resultado encontrado</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Money } from 'v-money'
import ModalToReverseCardTransactions from './ToReverseCardTransactionsModal'

export default {
  name: 'SearchTransactions',
  data () {
    return {
      filter: {
        cardBrand: '',
        searchType: 'nsu',
        paidAt: null,
        type: '',
        status: []
      },
      cardTransactionsList: null,
      count: 0,
      perPage: 10,
      cardTransactionSelected: [],
      isReplay: false
    }
  },
  methods: {
    async search () {
      this.$refs.spinner.show('Pesquisando transações...')
      if (this.filter.amount === 0) {
        this.filter.amount = null
      }
      var response = await this.$api.cardTransactions.list(this.filter)
      this.cardTransactionsList = response.cardTransactions
      this.count = response.count
      this.$refs.spinner.hide()
    },
    acquirerStatus (cardTransaction) {
      cardTransaction.acquirerStatus = cardTransaction.acquirerCanceledAt ? 'Cancelada'
        : this.isReproved(cardTransaction) ? 'Reprovada'
          : this.isPending(cardTransaction) ? 'Pendente'
            : this.isApproved(cardTransaction) ? 'Aprovada'
              : (this.isContested(cardTransaction) ? 'Contestada'
                : 'Canc. negado')

      switch (cardTransaction.acquirerStatus) {
        case 'Cancelada': return 'badge-secondary'
        case 'Canc. negado': return 'badge-warning'
        case 'Contestada': return 'badge-danger'
        case 'Reprovada': return 'badge-reproved'
        case 'Aprovada': return 'badge-success'
        case 'Pendente': return 'badge-info'
        default: return 'badge'
      }
    },
    status (cardTransaction) {
      cardTransaction.status = this.isApproved(cardTransaction) ? 'Aprovada'
        : this.isReproved(cardTransaction) ? 'Reprovada'
          : this.isCanceled(cardTransaction) ? 'Cancelada'
            : this.isContested(cardTransaction) ? 'Contestada'
              : this.isPending(cardTransaction) ? 'Pendente'
                : null

      switch (cardTransaction.status) {
        case 'Aprovada': return 'badge-success'
        case 'Reprovada': return 'badge-reproved'
        case 'Cancelada': return 'badge-secondary'
        case 'Contestada': return 'badge-danger'
        case 'Pendente': return 'badge-info'
        default: return 'badge'
      }
    },
    isApproved (cardTransaction) {
      return cardTransaction.approvedAt &&
        !this.isReproved(cardTransaction) &&
        !this.isCanceled(cardTransaction) &&
        !this.isContested(cardTransaction) &&
        !this.isPending(cardTransaction)
    },
    isReproved (cardTransaction) {
      return !!cardTransaction.reprovedAt
    },
    isCanceled (cardTransaction) {
      return !!cardTransaction.canceledAt &&
        !this.isContested(cardTransaction)
    },
    isContested (cardTransaction) {
      return !!cardTransaction.contestedOn
    },
    isPending (cardTransaction) {
      return !cardTransaction.capturedAt && cardTransaction.dueCaptureDate
    },
    reset () {
      this.$data.filter = {
        cardBrand: '',
        searchType: 'nsu',
        paidAt: null,
        type: null,
        status: []
      }
    },
    async turnPage (numberPage) {
      const end = numberPage * this.perPage
      const start = end - this.perPage
      this.filter.index = start
      this.filter.length = this.perPage
      await this.search()
    },
    emitCardTransaction (nsu, isReplay) {
      this.isReplay = isReplay
      this.cardTransactionSelected = []
      this.cardTransactionSelected.push(nsu)
    }
  },
  watch: {
    'filter.status': async function () {
      await this.search()
    }
  },
  components: {
    Money,
    ModalToReverseCardTransactions
  }
}
</script>
